export default "__VITE_ASSET__ynT32FP9__"